import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e3c01b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Options")
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "profile-img" }
const _hoisted_4 = { class: "img-box" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Nome completo")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Nome")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Cognome")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Email")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Avatar")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Seleziona")

import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonAvatar,
  IonLabel,
  IonItem,
  IonInput,
  IonList,
  // IonListHeader,
  IonSelect,
  IonSelectOption,
  IonCol,
  IonRow,
  IonButton,
  // IonIcon,
} from '@ionic/vue';
import UserService from "@/api/users/UserService";
import {useRouter} from "vue-router";
import {computed, ref} from "vue"
import store from '@/store'



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const {
  data,
  colorOptions,
  fetchUser,
  getUser,
  resolveUserColor,
  takePhoto,
  resolveUserAvatar,
} = UserService()
fetchUser()

const currentData = ref(JSON.parse(localStorage.getItem('userData') || '{}'))

const isOpenRef = ref(false)

const avatarImg = computed(() => JSON.parse(localStorage.getItem('userData') || '{}').avatar)

const setOpen = (state: boolean) => isOpenRef.value = state;

const updateCustomization = () => {
  const sendData = {
    //se l'utente non ha il colore assegno il colore Royal Blue di default
    'color': currentData.value.color ? currentData.value.color : colorOptions[5],
    // 'avatar': currentData.value.avatar.name
  }
  store.dispatch('user/updateUser', sendData).then(() => {
    fetchUser()
  })
}

const updateAvatar = () => {
  takePhoto().then(() => {
    fetchUser()
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton), { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (currentData.value && Object.values(_unref(getUser)()).length > 1)
        ? (_openBlock(), _createBlock(_unref(IonContent), {
            key: 0,
            fullscreen: true
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(IonList), { lines: "none list" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonRow), { class: "row profile" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCol), { size: "5" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_unref(IonAvatar), { class: "fit-avatar" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: _unref(resolveUserAvatar)(_unref(getUser)()).avatar,
                                      alt: _unref(resolveUserAvatar)(_unref(getUser)()).printable_name
                                    }, null, 8, _hoisted_5)
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonCol), { size: "7" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonItem), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), { position: "floating" }, {
                                  default: _withCtx(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(IonInput), {
                                  type: "text",
                                  placeholder: currentData.value.fullName,
                                  value: currentData.value.fullName,
                                  readonly: ""
                                }, null, 8, ["placeholder", "value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonInput), {
                          type: "text",
                          placeholder: currentData.value.first_name,
                          value: currentData.value.first_name,
                          readonly: ""
                        }, null, 8, ["placeholder", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonInput), {
                          type: "text",
                          placeholder: currentData.value.last_name,
                          value: currentData.value.last_name,
                          readonly: ""
                        }, null, 8, ["placeholder", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonInput), {
                          type: "text",
                          placeholder: currentData.value.email,
                          value: currentData.value.email,
                          readonly: ""
                        }, null, 8, ["placeholder", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Colore " + _toDisplayString(_unref(resolveUserColor)() ? _unref(resolveUserColor)().name : null), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonAvatar), {
                          style: _normalizeStyle('background-color: '+currentData.value.color)
                        }, null, 8, ["style"]),
                        _createVNode(_unref(IonSelect), {
                          placeholder: "Cambia",
                          interface: "action-sheet",
                          modelValue: currentData.value.color,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentData.value.color) = $event)),
                          onIonChange: updateCustomization
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorOptions), (color) => {
                              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                key: color.hex,
                                value: color.hex
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(color.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonButton), {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (updateAvatar()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})